import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Step, Icon } from 'semantic-ui-react';

import { Filter } from 'Containers/';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { initialize } from './state/actions';
import UnclosedDatesStep from './components/UnclosedDates';
import DownloadRosterStep from './components/DownloadRoster';
import CloseSchoolYearStep from './components/CloseSchoolYear';

class CloseSchoolYearComponent extends Component {
  componentDidMount() {
    this.props.initialize();
    this.props.setNotificationDialog(
      NOTIFICATION_DIALOG_MESSAGES.CLOSE_SCHOOL_YEAR_WARNING
    );
  }

  StepsEnum = {
    unclosedDates: 1,
    downloadRoster: 2,
    closeSchoolYear: 3,
  };

  state = {
    activeStep: this.StepsEnum.unclosedDates,
    completedSteps: [],
  };

  get steps() {
    const { completedSteps } = this.state;
    const { fiscalYear } = this.props;

    return [
      {
        key: this.StepsEnum.unclosedDates,
        title: 'Unclosed Dates',
        description: `View unclosed dates for the fiscal year.`,
        icon: 'search',
        disabled: () => false,
        render: () => (
          <UnclosedDatesStep
            nextStep={this.nextStep}
            isComplete={completedSteps.some(
              x => x === this.StepsEnum.unclosedDates
            )}
            fiscalYear={fiscalYear}
          />
        ),
      },
      {
        key: this.StepsEnum.downloadRoster,
        title: 'Download Roster',
        description: 'Download the Roster/Current Balance report.',
        icon: 'download',
        disabled: () =>
          !completedSteps.some(x => x === this.StepsEnum.downloadRoster),
        render: () => (
          <DownloadRosterStep
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            stepComplete={this.stepComplete}
            isComplete={completedSteps.some(
              x => x === this.StepsEnum.downloadRoster
            )}
            fiscalYear={fiscalYear}
          />
        ),
      },
      {
        key: this.StepsEnum.closeSchoolYear,
        title: 'Close School Year',
        description: 'Kick off the process to close the school year.',
        icon: 'checked calendar',
        disabled: () =>
          !completedSteps.some(x => x === this.StepsEnum.closeSchoolYear),
        render: () => (
          <CloseSchoolYearStep
            prevStep={this.prevStep}
            stepComplete={this.stepComplete}
            isComplete={completedSteps.some(
              x => x === this.StepsEnum.closeSchoolYear
            )}
            fiscalYear={fiscalYear}
          />
        ),
      },
    ];
  }

  stepComplete = () => {
    const { activeStep, completedSteps } = this.state;

    if (!completedSteps.some(s => s === activeStep)) {
      this.setState({ completedSteps: [...completedSteps, activeStep] });
    }
  };

  nextStep = () => {
    const { activeStep } = this.state;

    this.stepComplete();

    if (activeStep === Object.values(this.StepsEnum).pop()) {
      return;
    }

    this.setState({ activeStep: activeStep + 1 });
  };

  prevStep = () => {
    const { activeStep } = this.state;

    if (activeStep === Object.values(this.StepsEnum).shift()) {
      return;
    }

    this.setState({ activeStep: activeStep - 1 });
  };

  render() {
    const { completedSteps, activeStep } = this.state;
    const { initializing, fiscalYear } = this.props;

    return (
      <Fragment>
        {initializing ? (
          <LoadingPage />
        ) : (
          <Fragment>
            <Filter title={`Close School Year ${fiscalYear}`} newRow>
              <Step.Group widths={3}>
                {this.steps.map(step => (
                  <Step
                    completed={completedSteps.some(c => c === step.key)}
                    active={activeStep === step.key}
                    disabled={step.disabled()}
                    key={step.key}
                    onClick={() => {
                      this.setState({ activeStep: step.key });
                    }}
                  >
                    <Icon name={step.icon} />
                    <Step.Content>
                      <Step.Title>{step.title}</Step.Title>
                      <Step.Description>{step.description}</Step.Description>
                    </Step.Content>
                  </Step>
                ))}
              </Step.Group>
            </Filter>
            {//Render the active step.
            this.steps.find(x => x.key === activeStep).render()}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  initialize,
  setNotificationDialog,
};

const mapStateToProps = state => {
  const {
    CloseSchoolYear: { initializing, fiscalYear },
  } = state;

  return {
    initializing,
    fiscalYear,
  };
};

export const CloseSchoolYear = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CloseSchoolYearComponent)
);



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/CloseSchoolYear.js